
/**
 * State for the options bar component
 *
 * @export
 * @class State
 */
export class State {
	loading: boolean;
	priceUnit: string;
	viewToShow: string;
}

export const initialState: State = {
	loading: false,
	priceUnit: 'cash',
	viewToShow: 'calendar',
};
